import React from "react";
import { cx } from "class-variance-authority";

import "./Container.scss";

type ContainerProps = React.PropsWithChildren<{
    as?: React.ElementType;
    className?: string;
}> &
    React.HTMLAttributes<HTMLElement>;

export function Container({ as: Component = "div", className, children, ...props }: ContainerProps) {
    return (
        <Component className={cx("container", className)} {...props}>
            {children}
        </Component>
    );
}
